import { render, staticRenderFns } from "./InfoItem.vue?vue&type=template&id=036e5842&scoped=true&lang=pug&"
import script from "./InfoItem.vue?vue&type=script&lang=js&"
export * from "./InfoItem.vue?vue&type=script&lang=js&"
import style0 from "./InfoItem.vue?vue&type=style&index=0&id=036e5842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e5842",
  null
  
)

component.options.__file = "InfoItem.vue"
export default component.exports